// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    zipCode: state.components.contactUsForm.fieldValues["zipCode"],
    topics: state.components.contactUsForm.fieldValues["topic"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ZipCodeStyles {
    zipCodeTextField?: TextFieldPresentationProps;
}

export const zipCodeStyles: ZipCodeStyles = {
    zipCodeTextField: {
        cssOverrides: {
            formInputWrapper: css`
                padding-right: ${pxToRem(20)};
            `,
        },
    },
};

const styles = zipCodeStyles;

const ZipCode: React.FC<Props> = ({ fields, zipCode, topics, setFieldValue }) => {
    const { label, hintText } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [zipCodeErrorMessage, setZipCodeErrorMessage] = React.useState("");
    const [requiredZipCode, setRequiredZipCode] = React.useState(false);

    React.useEffect(() => {
        if (topics === "Product Inquiries") {
            contactFormContext.validators.zipCode = validateZipCode;
            setRequiredZipCode(true);
            if (zipCode === "") {
                validateZipCode();
            }
        } else {
            setRequiredZipCode(false);
        }
    }, [zipCode, topics]);

    const validateZipCode = () => {
        const errorMessage = !zipCode ? (siteMessage("Field_Required", label) as string) : "";
        setZipCodeErrorMessage(errorMessage);
        return !errorMessage;
    };

    const ZipCodeChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "zipCode", value: event.target.value });
    };

    return requiredZipCode ? (
        <TextField
            {...styles.zipCodeTextField}
            label={label}
            placeholder={hintText}
            value={zipCode || ""}
            error={zipCodeErrorMessage}
            onChange={ZipCodeChangeHandler}
        />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ZipCode),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Zip Code",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter Zip Code",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
